// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mono-text{white-space:pre-wrap;word-break:break-word;font-size:10pt}.mono-text .dot{opacity:.4}.mono-text .dot:before{content:\"·\";position:absolute}.hide-non-print .mono-text .dot{opacity:0}", ""]);
// Exports
module.exports = exports;
